import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { useWizardContext } from "./hooks";

interface Props {
  className?: string;
}

export const WizardProgress = ({ className }: Props) => {
  const { steps, activeStepIndex, disabled } = useWizardContext();

  const progress = ((activeStepIndex + 1) / steps.length) * 100;

  return (
    <div
      className={twMerge(
        "bg-v2-highlight px-6 text-xs text-v2-secondary border-t border-v2-tertiary h-[60px]",
        "flex flex-col items-start justify-center gap-2",
        className,
      )}
    >
      <div>
        Step {activeStepIndex + 1} of {steps.length}
      </div>
      <div className="h-1 w-full bg-v2-action-tertiary rounded-full overflow-hidden">
        <div
          className={clsx("h-full", {
            "bg-v2-action": !disabled,
            "bg-v2-gray/200": disabled,
          })}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};
